import { useEffect, useState } from "react";
import type { Tracker } from "types";

import { initMixpanel, makeMixPanelTracker } from "./index";

// Hook for initializing Mixpanel Tracker
export const useMixpanelTracker = () => {
    const [tracker, setTracker] = useState<Tracker | null>(null);

    useEffect(() => {
        const mixpanel = initMixpanel();

        if (mixpanel) {
            const mixpanelTracker = makeMixPanelTracker(mixpanel);
            setTracker(mixpanelTracker);
        }
    }, []);

    return tracker;
};
